import React from 'react';
import styled from 'styled-components/macro';


const CloseIcon = (props) => {
    return (
        <Container {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M23.23,24c-.2,0-.39-.07-.54-.22l-10.69-10.69L1.31,23.78c-.3.3-.78.3-1.08,0s-.3-.78,0-1.08l10.69-10.69L.22,1.31C-.07,1.01-.07.52.22.22S1.01-.07,1.31.22l10.69,10.69L22.69.22c.3-.3.78-.3,1.08,0s.3.78,0,1.08l-10.69,10.69,10.69,10.69c.3.3.3.78,0,1.08-.15.15-.35.22-.54.22Z"/>
            </svg>
        </Container>
    );
};


export default CloseIcon;


const Container = styled.span`
    display: inline-block;
    vertical-align: middle;
    height: 1em;
    
    svg {
        height: 100%;
        width: auto;
        fill: currentColor;
    }
`;
